import React from "react";
import { FormHelperText, InputAdornment } from "@material-ui/core";

import { CheckboxField } from "../../../../features/forms/fields/checkbox-field/checkbox-field.component";
import { IUser } from "../../../../types/user/iuser.interface";
import { workOderApprovalStatuses } from "../../../../types/approval-status/approval-statuses.constant";

import { Autocomplete } from "../../inputs/autocomplete/autocomplete.component";
import { Datepicker } from "../../inputs/date-picker/date-picker.component";
import { matchById, matchByValue } from "../../inputs/autocomplete/autocomplete.functions";

import { FiltersProps } from "../filters.props";
import { useFiltersStyles } from "../filters.styles";

export const WorkOrderFilterFields = (props: FiltersProps) => {
  const classes = useFiltersStyles();

  return (
    <>
      <Autocomplete
        control={props.control}
        label="Assignee"
        limitTags={2}
        name="assignee"
        optionLabel={(user: IUser) => `${user.firstName} ${user.lastName}`}
        optionSelected={matchById}
        options={props.optionLists.users!}
      />
      <Autocomplete
        control={props.control}
        label="Creative Prime"
        limitTags={2}
        name="creativePrime"
        optionLabel={(user: IUser) => `${user.firstName} ${user.lastName}`}
        optionSelected={matchById}
        options={props.optionLists.primes!}
      />
      <div className={classes.dateRange}>
        <Datepicker
          control={props.control}
          error={!!props.errors?.dateTo}
          label="Due From"
          name="dateFrom"
        />
        <span>to</span>
        <Datepicker
          control={props.control}
          error={!!props.errors?.dateTo}
          label="Until"
          name="dateTo"
        />
      </div>
      {props.errors?.dateTo && (
        <FormHelperText className={classes.error} error={true}>
          {props.errors.dateTo.message}
        </FormHelperText>
      )}
      <Autocomplete
        control={props.control}
        label="Status"
        limitTags={2}
        name="status"
        optionSelected={matchByValue}
        options={workOderApprovalStatuses}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <CheckboxField form={props.form} label="Not: " name="statusInverted" noAuthRequired />
            </InputAdornment>
          ),
        }}
      />
    </>
  );
};
